// extracted by mini-css-extract-plugin
module.exports = {"inlineSelect":"InlineSelect_inlineSelect__17H_z","green":"InlineSelect_green__3vX2L","orange":"InlineSelect_orange__17mNn"};